import { useEffect, useState } from 'react';

export const useToggle = (initialState: boolean = false) => {
  const [toggle, setToggle] = useState<boolean>(initialState);

  useEffect(() => {
    if (initialState != null) setToggle(initialState);
  }, [initialState]);

  const handleToggle = (isChecked: boolean) => setToggle(isChecked);

  return { toggle, handleToggle };
};
